export function getUserDetails() {
  const userDetails = {};
  const username = sessionStorage.getItem('username');
  const token = sessionStorage.getItem('token');

  if (username && token) {
    userDetails.userName = username;
    userDetails.token = token;

    return userDetails;
  }

  return undefined;
}

export function isGuestOrFreemiumUser(user) {
  const { authenticated } = user || {};
  const isGuestOrFreeUser = (!authenticated || user?.user?.account?.freemiumUser) && !user?.user?.activeSubscription;

  return isGuestOrFreeUser && !user?.user?.account?.anchor;
}
